import { Form, Input, Button } from "antd";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { FaArrowRight } from "react-icons/fa6";
import { useState } from "react";

export default function PasswordStepForm({ onSubmit }) {
  const [form] = Form.useForm();
  const [passwordMatch, setPasswordMatch] = useState(true);

  const handlePasswordChange = () => {
    const password = form.getFieldValue("newPassword");
    const confirmPassword = form.getFieldValue("confirmPassword");

    if (!confirmPassword) return;
    setPasswordMatch(password === confirmPassword);
  };

  return (
    <Form
      layout="vertical"
      onFinish={onSubmit}
      form={form}
      onValuesChange={handlePasswordChange}
      className="login-reg-form"
    >
      <Form.Item
        name="newPassword"
        label={<span className="label">নতুন পাসওয়ার্ড</span>}
        rules={[{ required: true, message: "নতুন পাসওয়ার্ড দিন" }]}
        hasFeedback
      >
        <Input.Password
          size="large"
          placeholder="নতুন পাসওয়ার্ড"
          className="rounded login-form-input"
          iconRender={(visible) =>
            visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
          }
        />
      </Form.Item>

      <Form.Item
        name="confirmPassword"
        label={<span className="label">পাসওয়ার্ড নিশ্চিত করুন</span>}
        dependencies={["newPassword"]}
        hasFeedback
        rules={[
          { required: true, message: "পাসওয়ার্ড নিশ্চিত করুন" },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("newPassword") === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error("পাসওয়ার্ড মিলছে না"));
            },
          }),
        ]}
      >
        <Input.Password
          size="large"
          placeholder="পাসওয়ার্ড নিশ্চিত করুন"
          className="rounded login-form-input"
          iconRender={(visible) =>
            visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
          }
        />
      </Form.Item>



      <Button
        type="primary"
        htmlType="submit"
        size="large"
        className="login-regictation-submit-btn"
      >
        সাবমিট করুন<FaArrowRight />
      </Button>
    </Form>
  );
}
